<template>
    <!-- 添加/编辑私教课程 -->
    <el-dialog
        class="lessons-dialog"
        :visible.sync="visible"
        :title="title"
        left>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            :status-icon="true"
            label-position="right"
            label-width="120px"
            label-suffix=":">
            <div>
                <el-form-item :label="$t('Course.name')" prop="name">
                    <el-input
                        v-model="form.name"
                        :placeholder="$t('Fill.course_name')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Course.image')">
                    <file-upload
                        v-if="form.images.length < 4"
                        ref="upload"
                        @input="addImg(arguments)">
                        <div class="iconfont icon-fitness-jiahao lessons-image"></div>
                    </file-upload>
                    <!-- 图片显示 -->
                    <div
                        v-for="(item, index) in form.images"
                        :key="index"
                        class="add-lessons-pic"
                        :style="`background-image: url(${item});`">
                        <div
                            @click="deleteImg(index)"
                            class="iconfont icon-fitness-jianshanchu-yuankuang add-lessons-delete">
                        </div>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('Fill.course_time')" prop="duration">
                    <el-input
                        class="lessons-minute"
                        type="number"
                        v-model.number="form.duration"
                        :placeholder="$t('Fill.course_fill_time')"></el-input>
                        &nbsp;&nbsp;{{ $t('Common.minute') }}
                </el-form-item>
                <el-form-item :label="$t('Sell.store')" prop="storeIds">
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllChange"
                    >{{ $t('Course.check_all') }}</el-checkbox>
                    <div class="lessons-check-store">
                        <el-checkbox-group
                            v-model="form.storeIds"
                            @change="handleCheckedStoresChange">
                            <el-checkbox
                                v-for="item in stores"
                                :label="item.id"
                                :key="item.id">
                                {{ item.name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('Course.appoint_coach')">
                    <el-checkbox
                        :indeterminate="isCourseIndeterminate"
                        v-model="checkAllCourses"
                        @change="handlecheckAllCoursesChange"
                    >{{ $t('Course.check_all') }}</el-checkbox>
                    <div class="lessons-check-store">
                        <el-checkbox-group
                            v-model="form.coachIds"
                            @change="handleCheckedCoursesChange">
                            <el-checkbox
                                v-for="item in courses"
                                :label="item.id" :key="item.id">
                                {{ item.nickname }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item
                    prop="singlePurchase"
                    class="lessons-buy"
                    :label="$t('Lesson.anthor_card')">
                    <el-radio v-model="form.singlePurchase" label="1">{{ $t('Common.yes') }}</el-radio>
                    <el-radio v-model="form.singlePurchase" label="0">{{ $t('Common.no') }}</el-radio>
                </el-form-item>
                <el-form-item :label="$t('Course.introduction')">
                    <el-input
                        class="lessons-desc"
                        v-model="form.description"
                        type="textarea"
                        :placeholder="$t('Fill.course_introduction')">
                    </el-input>
                </el-form-item>
            </div>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{ $t('Common.close') }}</el-button>
            <el-button @click="confirm" type="primary">{{ $t('Common.save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, Radio, DatePicker, Tree } from 'element-ui';
import FileUpload from '@/components/base/FileUpload.vue';
import filterRole from '@/mixins/filterRole.js';

export default {
    name: 'add-lessons',
    components: {
        ElDialog: Dialog,
        ElRadio: Radio,
        ElTree: Tree,
        ElDatePicker: DatePicker,
        FileUpload,
    },
    mixins: [filterRole],
    data() {
        return {
            title: this.$t('Course.add_personal'),
            id: null,
            form: {
                singlePurchase: '0',
                description: '',
                name: '',
                duration: null,
                images: [],
                storeIds: [],
                coachIds: [],
            },
            visible: false,
            rules: {
                name: { type: 'string', required: true, message: this.$t('Common.name_placeholder') },
                duration: { required: true, type: 'number', message: this.$t('Fill.course_fill_time') },
                storeIds: {
                    required: true,
                    message: this.$t('Course.choose_store'),
                },
                singlePurchase: { type: 'string', required: true },
            },
            checkAll: false,
            stores: [],
            isIndeterminate: false,
            checkAllCourses: false,
            courses: [],
            isCourseIndeterminate: false,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    computed: {
    },
    methods: {
        resetForm() {
            // 清空form数据
            setTimeout(() => {
                this.$refs.form.resetFields();
                this.$refs.form.clearValidate();
            }, 0);
            // 清空数据
            this.form = {
                singlePurchase: '0',
                description: '',
                name: '',
                duration: null,
                images: [],
                storeIds: [],
                coachIds: [],
            };
            this.id = null;
            this.checkAll = false;
            this.isIndeterminate = false;
            this.checkAllCourses = false;
            this.isCourseIndeterminate = false;
        },
        async open(type, id) {
            this.fetchCoach();
            await this.fetchStore();
            if (type === 'edit') {
                this.fetchData(id);
                this.id = id;
                this.title = this.$t('Course.edit_personal');
            } else {
                this.title = this.$t('Course.add_personal');
            }
            this.visible = true;
        },
        fetchData(id) {
            API.get(`lesson/coach/${id}`).then(res => {
                res.singlePurchase = res.singlePurchase ? '1' : '0';
                this.form = res;
                if (res) {
                    this.handleCheckedStoresChange(this.form.storeIds);
                    this.handleCheckedCoursesChange(this.form.coachIds);
                }
            }).catch(() => {}).finally(() => {});
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                this.handlePost();
            });
        },
        handlePost() {
            const form = Object.assign({}, this.form);
            form.singlePurchase = Number(form.singlePurchase) !== 0;
            if (this.id) {
                API.put(`lesson/coach/${this.id}`, form).then(() => {
                    $ele.$message.success(this.$t('Message.success'));
                    this.$emit('fetchData');
                    this.resetForm();
                    this.visible = false;
                });
            } else {
                API.post('lesson/coach', form).then(() => {
                    $ele.$message.success(this.$t('Message.success'));
                    this.$emit('fetchData');
                    // 清空数据
                    this.resetForm();
                    this.visible = false;
                });
            }
        },
        addImg(args) {
            this.form.images.push(args[0]);
        },
        deleteImg(index) {
            this.form.images.splice(index, 1);
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        handleCheckAllChange(val) {
            // this.form.storeIds = val ? this.stores : [];
            this.form.storeIds = val ? this.stores.map(el => el.id) : [];
            this.isIndeterminate = false;
        },
        handleCheckedStoresChange(value) {
            const checkedCount = value.length;
            this.checkAll = checkedCount === this.stores.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
        },
        // 教练
        async fetchCoach() {
            const ids = [7, 8];
            this.courses = await this.filterRole(null, ids);
        },
        handlecheckAllCoursesChange(val) {
            // this.form.coachIds = val ? this.courses : [];
            this.form.coachIds = val ? this.courses.map(el => el.id) : [];
            this.isCourseIndeterminate = false;
        },
        handleCheckedCoursesChange(value) {
            const checkedCount = value.length;
            this.checkAllCourses = checkedCount === this.courses.length;
            this.isCourseIndeterminate = checkedCount > 0 && checkedCount < this.courses.length;
        },
    },
};
</script>

<style lang="scss">
.lessons-dialog {
    .el-dialog {
        width: 540px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 88vh;
        overflow-y: auto;
    }
}
.el-dialog--center .el-dialog__body {
    padding: 25px 65px 0 25px;
}
.avator-bg {
    width: 75px;
    height: 100px;
    background: #697a8e;
    color: #fff;
    margin-bottom: 10px;

    .iconfont {
        font-size: 50px;
    }

    .avatar {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }
}
.lessons-image {
    width: 100px;
    height: 60px;
    border: 1px solid #e6e6e6;
    position: relative;
    margin-right: 10px;
    border-radius: 3px;

    &:hover {
        background: #05abef;
    }

    &::before {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 50px;
        color: #f2f2f2;

        &:hover {
            color: #fff;
        }
    }
}
.lessons-minute {
    width: 200px;
}

.customer-line {
    width: 100%;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 20px;
}
.customer-num {
    width: 360px;
}
.customer-email {
    width: 26%;
}
.customer-area {
    width: 20%;
}
.customer-address {
    width: 40% ;
}
.el-form-item__label {
    font-size: 13px;
}
.customer-club {
    .el-form-item__label {
        width: 170px !important;
    }
    .el-form-item {
        display: flex;
        justify-content: flex-start;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
textarea {
    width: 100%;
    height: 100px;
}
.customer-label {
    display: inline-block;
    font-size: 12px;
    color: grey;
    border: 1px solid #e6e6e6;
    border-radius: 24px;
    margin: 0 10px 10px 0;
    line-height: 1;
    padding: 6px 20px;
    cursor: pointer;
}
.active {
    color: #05abef;
    border-color: #05abef;
}
.lessons-check-store {
    margin-top: 15px;
    border: 1px solid #e6e6e6;
    padding: 10px;
    max-height: 90px;
    overflow-y: auto;
    .el-checkbox {
        margin-left: 30px !important;
    }
}
.lessons-buy {
    .el-form-item__label {
        width: 170px !important;
    }
}
.lessons-desc {
    height: 120px;
}
.add-lessons-pic {
    width: 100px;
    height: 60px;
    background-size: cover;
    background-position: center;
    display: inline-block;
    margin-right: 10px;
    position: relative;

    &:last-child {
        margin-right: 0;
    }
}
.add-lessons-delete {
    position: absolute;
    right: -6px;
    top: -15px;
    color: red;
}
</style>
